module.exports = __webpack_public_path__ + "img/biying.fc36a1fb.png";